import { useState, useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import useWindowSize from '#client/hooks/useWindowSize';

import { FabLeft, FabRight } from './CarouselControls.styles';

// card size + gap = 328px + 24px = 352px
const CARD_SIZE = 328 + 24;

export const CarouselControls = ({ carouselRef, onBack, onNext }) => {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [width] = useWindowSize();

  const updateArrowsState = useCallback(() => {
    const container = carouselRef?.current;
    if (container) {
      const { scrollLeft, scrollWidth, offsetWidth } = container;
      setShowLeft(Boolean(scrollLeft));
      // +1 fixes button display for screen size with odd width numbers
      setShowRight(Boolean(offsetWidth + scrollLeft + 1 < scrollWidth));
    }
  }, [carouselRef]);

  useEffect(() => {
    const container = carouselRef?.current;
    if (container) {
      updateArrowsState();
      container.addEventListener('scroll', updateArrowsState);
    }
    return () => {
      container.removeEventListener('scroll', updateArrowsState);
    };
  }, [carouselRef, updateArrowsState]);

  useEffect(() => {
    if (width) updateArrowsState();
  }, [updateArrowsState, width]);

  const onLeftClick = () => {
    onBack();
    carouselRef?.current.scroll({
      left: carouselRef.current.scrollLeft - CARD_SIZE,
      behavior: 'smooth'
    });
  };

  const onRightClick = () => {
    onNext();
    carouselRef?.current.scroll({
      left: carouselRef.current.scrollLeft + CARD_SIZE,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {showLeft && (
        <FabLeft aria-label="left arrow" onClick={onLeftClick}>
          <KeyboardArrowLeftIcon sx={{ color: '#FFF' }} />
        </FabLeft>
      )}
      {showRight && (
        <FabRight aria-label="right arrow" onClick={onRightClick}>
          <KeyboardArrowRightIcon sx={{ color: '#FFF' }} />
        </FabRight>
      )}
    </>
  );
};

CarouselControls.propTypes = {
  carouselRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  onNext: PropTypes.func,
  onBack: PropTypes.func
};

CarouselControls.defaultProps = {
  onNext: () => {},
  onBack: () => {}
};
